import React, { useState } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { get } from 'lodash';

import Element from '../../components/element';
import Flex from '../../components/flex';
import Text from '../../components/text';
import GradientDivider from '../../components/gradientDivider';
import useToast from '../../components/Toast/useToast';
import useStyles from './style';
import { apiRequest } from '../../api/actions';
import { ReactComponent as LogoSVG } from '../../assets/icons/ThorneHealthLogo.svg';

const Ratings = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ratingValue, setRatingValue] = useState(-1);
  const [openSnackbar] = useToast();
  let ratingsArray = [
    { color: '#fff', rating: 0, bgColor: '#a90a0a' },
    { color: '#fff', rating: 1, bgColor: '#a90a0a' },
    { color: '#fff', rating: 2, bgColor: '#a90a0a' },
    { color: '#fff', rating: 3, bgColor: '#a90a0a' },
    { color: '#fff', rating: 4, bgColor: '#a90a0a' },
    { color: '#fff', rating: 5, bgColor: '#a90a0a' },
    { color: '#fff', rating: 6, bgColor: '#a90a0a' },
    { color: '#000', rating: 7, bgColor: '#d8c120' },
    { color: '#000', rating: 8, bgColor: '#d8c120' },
    { color: '#fff', rating: 9, bgColor: '#53a90a' },
    { color: '#fff', rating: 10, bgColor: '#53a90a' }
  ];
  const getRatingValue = value => {
    setRatingValue(value);
  };
  const submitRating = () => {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      patientId: params.get('pid'),
      notes: 'string',
      rating: ratingValue
    };
    const request = {
      method: 'put',
      url: `visit/${params.get('vid')}/feedback`,
      data: payload
    };
    const meta = {
      onSuccess: res => {
        if (!res.data.error) {
          localStorage.setItem('feedback', "true")
          openSnackbar('Your feedback has been submitted.');
          setRatingValue(-1);
          navigate(-1);
        } else {
          openSnackbar(
            get(res, 'data.error.message') ||
            'Something went wrong. Please try again.',
            'warn'
          );
        }
      }
    };

    dispatch(apiRequest(request, meta));
  };
  return (
    <Element background="white" width=" 80%" margin="auto" padding="50px 40px">
      <Element type={LogoSVG} width="25%" marginLeft="30px" />
      <GradientDivider />
      <Element type="p" fontFamily="GTAM" fontSize="20px" marginBottom="35px">
        "How likely is it that you would recommend Thorne Lab to a friend or
        colleague?"
      </Element>
      <Flex>
        <Text size="14px" color="#959595" family="GTAR" marginRight="145px">
          0= Not at all likely
        </Text>
        <Text size="14px" color="#959595" family="GTAR" marginRight="125px">
          5= Neutral
        </Text>
        <Text size="14px" color="#959595" family="GTAR">
          10= Extremely Likely
        </Text>
      </Flex>
      {/* | */}
      <Flex>
        {ratingsArray.map(each => {
          return (
            <Element
              color={each.color}
              background={each.bgColor}
              width="50px"
              height="50px"
              padding="15px 20px"
              cursor="pointer"
              border={ratingValue === each.rating ? '2px solid #222222' : ''}
              onClick={() => {
                getRatingValue(each.rating);
              }}
            >
              {each.rating}
            </Element>
          );
        })}
      </Flex>
      <button
        className={`${classes.btn} ${classes.submit}`}
        type="button" disabled={ratingValue <= 0}
        onClick={submitRating}
      >
        Submit
      </button>
    </Element>
  );
};

export default Ratings;
